<script setup>
import {useBaseStore} from "~/stores/base";
import Drawer from "~/components/Drawer.vue";
import Modal from "~/components/Modal.vue";

const BNTOMessage = useNuxtApp().$BNTOMessage
const router = useRouter()
const route = useRoute()

/** emits **/
const emits = defineEmits(["close", "confirm"])

/** props **/
const props = defineProps({
  open: {
    default: false
  }
})

/** data **/

/** computed **/
const isMobile = computed(() => useBaseStore().getterIsMobile)
const userInfo = computed(() => useBaseStore().getterUserInfo)

/** watch **/

/** methods **/

/** lifecycle **/

</script>

<template>
  <div class="modal-wishlist-remove-product-confirm-mobile" v-if="isMobile">
    <Drawer
      :open="open"
      @close="emits('close')"
      :btn-close-visible="true"
      :position="'bottom'"
      :border-radius="'8px 8px 0 0'"
      :z-index="4"
      :global-header-visible="false"
      :append-to-body="true"
    >
      <div class="modal-wishlist-remove-product-confirm-mobile-content">
        <div class="text">After unfavoriting, this item will also be removed from all capsules.</div>
        <div class="btn-container">
          <div class="btn-secondary" @click="emits('close')">cancel</div>
          <div class="btn-primary" @click="emits('confirm')">confirm</div>
        </div>
      </div>
    </Drawer>
  </div>
  <div class="modal-wishlist-remove-product-confirm-desktop" v-else>
    <Modal
      :open="open"
      :btn-close-visible="true"
      @close="emits('close')"
      :z-index="4"
      :append-to-body="true"
    >
      <div class="modal-wishlist-remove-product-confirm-desktop-content">
        <div class="text">After unfavoriting, this item will also be removed from all capsules.</div>
        <div class="btn-container">
          <div class="btn-secondary" @click="emits('close')">cancel</div>
          <div class="btn-primary" @click="emits('confirm')">confirm</div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<style lang="scss">
@import "src/assets/config";

.modal-wishlist-remove-product-confirm-mobile-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 44px;
  padding: 64px 16px 24px 16px;

  .text {
    color: $color-gray-800;
    font-family: "TWK Lausanne";
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: 20px; /* 142.857% */
  }

  .btn-container {
    width: 100%;
    display: flex;
    gap: 8px;

    div {
      width: 100%;
    }
  }
}

.modal-wishlist-remove-product-confirm-desktop-content {
  display: flex;
  width: 400px;
  padding: 48px 16px 24px 16px;
  flex-direction: column;
  align-items: center;
  gap: 44px;
  flex-shrink: 0;

  .text {
    color: $color-gray-800;
    font-family: "TWK Lausanne";
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: 20px; /* 142.857% */
  }

  .btn-container {
    width: 100%;
    display: flex;
    gap: 8px;

    div {
      width: 100%;
    }
  }
}
</style>
